import React,{useState,useEffect} from 'react'
import { Button,Box, LinearProgress,Menu,
    MenuItem ,Tooltip,IconButton} from '@material-ui/core';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import qs from 'qs';
import Badge from '@material-ui/core/Badge';
import MailIcon from '@material-ui/icons/Mail';
import ModalNotificacion from './ModNotif';
import io from "socket.io-client";
import {toast} from "react-toastify";
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import moment from 'moment';
const ENDPOINT = process.env.REACT_APP_SOCKET//"https://teleferico-socket.daduva.mx:5000";

const Notificacion = ({usuario}) => {
    let history = useHistory();
    const auxUsrID="19"
    const idusu= localStorage.getItem('UsuId');  
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0;      
    const source = axios.CancelToken.source();
    const socket = io(ENDPOINT,  {transports: ['websocket']});//se conecta     
    const Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs'   
    const [cargando, setCargando] = useState(false);
    
    const [lista, setLista] = useState([]);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [contadorBadge, setContadorBadge] = useState(0)

    useEffect(() => {
        //console.log(usuario);
        
        getLista(usuario)
 
        return () => {
            source.cancel();
        }
    }, [])
    
    useEffect(()=>{
        socket.on("/Notificacion/Agenda/Pendiente/Emit/", data => {                
            const info=JSON.parse(data)
            const nvocad=info.Usuarios+","
           //console.log(findNumberCad(idusu, nvocad),nvocad, idusu,info);
             if (findNumberCad(idusu, nvocad))  
            {                                
                const fchReg = moment.utc(info.freg).local(true).format("YYYY-MM-DD hh:mm")    
                
                const mensaje=`Tienes una nueva notificación, ${fchReg}` 
                    getLista()
                toast.info(mensaje,{                    
                    pauseOnFocusLoss: false,                    
                    toastId: `socket-nvo-Agenda${info.Key}`
                })                    
              
            }         
        });
        return () => socket.disconnect();   
    })


    function findNumberCad(num,cadena) {
   
        let nvoCad="",  bandera=false
        for (let index = 0; index < cadena.length; index++) {
            const element = cadena.charAt(index)
            //console.log(element);
            
            if (element==="," && !bandera) {
                //console.log("encontro id", nvoCad, num);
                
                if (nvoCad === num) {                    
                    bandera=true
                }
                nvoCad=""
            }else{
                nvoCad+=element
            }
        }
        return bandera
        //console.log(cadena, num, bandera);
        
    }

    const getLista = () => {  
        const data = qs.stringify({   
            Usuario:usuario.usrId ?? idusu,         
            idDispositivo: auxDispV,
        });
        const url = "/notificacion/pendiente";
        function respuesta(aux) {
          if (aux[0].Id !== "0"&& aux[0].Id !== 0 && aux[0].Id !== "-1"&& aux[0].Id !== -1) 
          {  //console.log(aux);
            setContadorBadge(aux.length)
            setLista(aux)
          }else{
            setLista([])
          }    
        }
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setCargando,history,source);
      };    

 

    const abrirModal=()=>{
        setModalAbierto(true)
    }

    const modalN= modalAbierto ? <ModalNotificacion modalAbierto={modalAbierto} setModalAbierto={setModalAbierto} 
                                    titulo={"Notificaciones"}  lista={lista} setLista={setLista} 
                                    contadorBadge={contadorBadge} setContadorBadge={setContadorBadge} /> :null
    const mostrarBadge =contadorBadge > 0 ?  <Tooltip title="Nuevas Notificaciones">
      <Badge color="error"  badgeContent={contadorBadge} size="small" onClick={abrirModal}>
            <MailIcon/>
          </Badge></Tooltip>
          :  <Tooltip title="Notificaciones">
                <Badge color={"inherit"}  badgeContent={contadorBadge} size="small" onClick={abrirModal}>
                    <MailIcon/>
                </Badge>
            </Tooltip>

    return (
    <div style={{marginRight:".7rem"}}>
        {modalN}
       {mostrarBadge}
    </div>
    )

}

export default Notificacion